import CurrencyFormat from 'react-number-format';
import { Col, Row } from 'reactstrap';
import ContentLoader from '../../../components/ContentLoader';
import { useDict } from '../../../contexts/LanguageContext';

const TransactionDashboard = (props) => {
    const { transactionSummaryData, isFetching } = props;

    const dict = useDict();

    const renderWithLoader = (component) => {
        if (isFetching) {
            return (
                <ContentLoader width="100" height="20" color="loader500">
                    <rect width="100%" height="100%" y="0" rx="4" ry="4" />
                </ContentLoader>
            );
        }
        return component;
    };

    return (
        <div className="transaction__summary" data-cy="transaction__summary">
            <Row>
                <Col xs={6}>{dict.totalInvestment}</Col>
                <Col
                    xs={6}
                    style={{
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {renderWithLoader(
                        <CurrencyFormat
                            value={transactionSummaryData?.invest || '0.00'}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    )}
                </Col>
            </Row>
            <Row>
                <Col xs={6}>- {dict.totalWithdrawal}</Col>
                <Col xs={6} style={{ textAlign: 'right' }}>
                    {renderWithLoader(
                        <>
                            (
                            <CurrencyFormat
                                value={transactionSummaryData?.withdrawal || '0.00'}
                                displayType="text"
                                thousandSeparator
                                prefix="฿ "
                            />
                            )
                        </>
                    )}
                </Col>
            </Row>
            <Row style={{ fontWeight: 'bold' }}>
                <Col xs={6}>{dict.balance}</Col>
                <Col
                    xs={6}
                    style={{
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {renderWithLoader(
                        <CurrencyFormat
                            value={transactionSummaryData?.balance || '0.00'}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default TransactionDashboard;
